"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarSlider = void 0;
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../redux/selectors");
var CarCardSlider_module_scss_1 = __importDefault(require("../components/carCardSlider/CarCardSlider.module.scss"));
var useCarSlider = function () {
    var swiperCardRef = (0, react_1.useRef)(null);
    var swiperHorizontalRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(0), activeIndex = _a[0], setActiveIndex = _a[1];
    var isSmall = (0, react_redux_1.useSelector)(selectors_1.mediaQuerySelector).isSmall;
    var slidesPerView = isSmall ? 3 : 6;
    var handleNext = (0, react_1.useCallback)(function () {
        var _a;
        (_a = swiperCardRef.current) === null || _a === void 0 ? void 0 : _a.swiper.slideNext();
    }, []);
    var handlePrev = (0, react_1.useCallback)(function () {
        var _a;
        (_a = swiperCardRef.current) === null || _a === void 0 ? void 0 : _a.swiper.slidePrev();
    }, []);
    var handleSlideChange = (0, react_1.useCallback)(function () {
        var _a, _b;
        var mainSwiper = (_a = swiperCardRef.current) === null || _a === void 0 ? void 0 : _a.swiper;
        var horizontalSwiper = (_b = swiperHorizontalRef.current) === null || _b === void 0 ? void 0 : _b.swiper;
        if (mainSwiper && horizontalSwiper) {
            var newIndex = mainSwiper.activeIndex;
            setActiveIndex(newIndex);
            horizontalSwiper.slideToLoop(newIndex);
        }
    }, []);
    var handleThumbnailClick = (0, react_1.useCallback)(function (index, event) {
        var _a, _b;
        if (event.target instanceof Element &&
            (event.target.closest(".".concat(CarCardSlider_module_scss_1.default.car_card_slider__box_vector__vector)) || event.target.closest('button'))) {
            return;
        }
        var mainSwiper = (_a = swiperCardRef.current) === null || _a === void 0 ? void 0 : _a.swiper;
        var horizontalSwiper = (_b = swiperHorizontalRef.current) === null || _b === void 0 ? void 0 : _b.swiper;
        if (mainSwiper && horizontalSwiper) {
            mainSwiper.slideToLoop(index);
            if (activeIndex - index >= 4) {
                horizontalSwiper.slideToLoop(activeIndex - 6);
            }
            else if (activeIndex > index) {
                horizontalSwiper.slideToLoop(activeIndex - 4);
            }
            else {
                horizontalSwiper.slideToLoop(index - 1);
            }
            setActiveIndex(index);
        }
    }, [activeIndex]);
    return {
        swiperCardRef: swiperCardRef,
        swiperHorizontalRef: swiperHorizontalRef,
        activeIndex: activeIndex,
        slidesPerView: slidesPerView,
        handleNext: handleNext,
        handlePrev: handlePrev,
        handleSlideChange: handleSlideChange,
        handleThumbnailClick: handleThumbnailClick,
    };
};
exports.useCarSlider = useCarSlider;
